import React from "react"
import { View } from "react-native"
import { IconImageM } from "@common/components/icons/IconsM"
import TextM from "@common/components/text/TextM"
import { lightenHexColor } from "@common/components/button/TouchableRippleM"

/**
 * Objective worked in a given live session: the student's first non-closed
 * pedagogical objective linked to that session. Returns null when none match.
 */
export function resolveSessionObjective(student, liveSessionId) {
    if (!Array.isArray(student?.pedagogical_objectives)) return null
    return (
        student.pedagogical_objectives
            .filter((obj) => obj?.status !== "closed")
            .find(
                (obj) =>
                    Array.isArray(obj?.live_sessions) &&
                    obj.live_sessions.some((ls) => ls?.id === liveSessionId)
            ) ?? null
    )
}

const ObjectiveSubjectsBadges = ({
    objective = null,
    student = null,
    liveSessionId = null,
    schoolSubjects = [],
    style = {},
    tinyMode = true,
    truncateNames = true,
}) => {
    // Determine the objective to use
    let targetObjective = objective

    // If no direct objective provided, find it from student and liveSessionId
    if (!targetObjective && student && liveSessionId) {
        targetObjective = resolveSessionObjective(student, liveSessionId)
    }

    if (!targetObjective?.subject_ids?.length) return null

    return (
        <View
            style={{
                flexDirection: "row",
                alignItems: "center",
                flex: 1,
                flexWrap: "wrap",
                ...style,
            }}
        >
            {targetObjective.subject_ids
                .map((subjectId, subIdx) => {
                    // Use loose comparison to handle string/number mismatches
                    const subject = schoolSubjects?.find(
                        (s) => s?.id == subjectId
                    )
                    if (!subject) return null

                    return (
                        <View
                            key={`${targetObjective.id}-${subject.id}`}
                            style={{
                                marginLeft: subIdx === 0 ? 0 : -4,
                                paddingVertical: 2,
                                paddingHorizontal: 3,
                                borderRadius: 6,
                                borderWidth: 1,
                                borderColor: subject?.color,
                                backgroundColor: lightenHexColor(
                                    subject?.color,
                                    90
                                ),
                                flexDirection: "row",
                                alignItems: "center",
                            }}
                        >
                            <IconImageM uri={subject?.icon} width={12} />
                            {(targetObjective.subject_ids.length === 1 ||
                                !tinyMode) && (
                                <TextM
                                    fontSize={9}
                                    fontWeight="SemiBold"
                                    style={{ marginLeft: 2 }}
                                    color={subject?.color}
                                >
                                    {truncateNames
                                        ? subject?.name?.slice(0, 4)
                                        : subject?.name}
                                </TextM>
                            )}
                        </View>
                    )
                })}
        </View>
    )
}

export default ObjectiveSubjectsBadges
